import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { STRICT_WS } from "./actionTypes";
import { strictWorkstationsSuccess, strictWorkstationsError } from "./actions";

// Include call API
import { getWorkstationsAPI } from "../../../api/workstations";

const workstationAPI = getWorkstationsAPI();

function* strictWorkstation({ payload: { ws, token, history } }) {

  try {

    const response = yield call(workstationAPI.strictPriorityWorkstation, ws, token);
    yield put(strictWorkstationsSuccess(response.message));
    history.go()
  } catch (error) {
    yield put(strictWorkstationsError(error));
  }
}

export function* watchStrictWorkstations() {
  yield takeEvery(STRICT_WS, strictWorkstation);
}

function* StrictWorkstationsSaga() {
  yield all([fork(watchStrictWorkstations)]);
}

export default StrictWorkstationsSaga;
